import React, { useEffect } from "react";

const ScrollReset = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return <></>;
};

export default ScrollReset;
